import { Box } from "@mui/material";
import React, { useEffect } from "react";
import { useDeleteNoteTable } from "../../../hook";
import {
  useFetchTableRunControl,
  useRunTable,
  useSetTableRunControl,
  useTable,
  useTableIsLoading,
  useTableRunControl,
  useTableSpec,
} from "../../../hook/table";
import { NoteBlockContainerLegacy } from "../../note";
import { SearchTable } from "../../searchTable";
import { TableBlock } from "../../../types/notebook/note/block/table";

export const TableBlockComponent: React.FC<{
  block: TableBlock;
}> = React.memo(({ block }) => {
  const tableId = block["table-id"];
  const table = useTable(tableId);
  const tableSpec = useTableSpec(tableId);
  const name = tableSpec?.name ?? table?.name;
  const description = tableSpec?.description;
  const deleteNoteTable = useDeleteNoteTable();
  const runTable = useRunTable();
  const [isLoading, setIsLoading] = useTableIsLoading(tableId);
  const tableRunControl = useTableRunControl(tableId);
  const runControlDefined = tableRunControl !== undefined;
  const isPaused = tableRunControl === "paused";
  const setTableRunControl = useSetTableRunControl();
  const fetchTableRunControl = useFetchTableRunControl();

  const onTogglePaused = () => {
    if (tableRunControl === undefined) return;
    setIsLoading(true);
    setTableRunControl({
      tableId,
      runControl: tableRunControl === "paused" ? "resumed" : "paused",
    }).finally(() => {
      setIsLoading(false);
    });
  };

  const handleRun = async () => {
    return runTable({ tableId })
      .catch((error) => {
        console.error("Failed to run table:", error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    if (!tableId) return;
    if (tableRunControl !== undefined) return;

    fetchTableRunControl(tableId);
  }, [tableId, tableRunControl]);

  return (
    <Box
      id={tableId}
      sx={{ display: "flex", flexDirection: "row", flexGrow: 1 }}
    >
      <NoteBlockContainerLegacy
        name={name ?? ""}
        description={description}
        onDelete={() => deleteNoteTable({ tableId })}
        onRun={handleRun}
        isLoading={isLoading}
        isPaused={isPaused}
        onTogglePaused={runControlDefined ? onTogglePaused : undefined}
      >
        <SearchTable tableId={tableId} />
      </NoteBlockContainerLegacy>
    </Box>
  );
});
